import React from 'react';

type Props = {
    label?: string;
    size?: 'sm' | 'md' | 'lg';
};

/**
 * Auro Domus brand spinner — rotirajući logo s opcionalnim labelom ispod.
 * Koristi se za initial load i za "ponovno dohvaćam" stanje (npr. nakon klika
 * na "Primijeni" u filterima P&L modula).
 */
export function BrandSpinner({ label, size = 'md' }: Props) {
    const dim = size === 'sm' ? 36 : size === 'lg' ? 96 : 64;

    return (
        <div className="bi-brand-spinner" role="status" aria-live="polite">
            <span className="bi-brand-spinner__logo-wrap" style={{ width: dim, height: dim }}>
                <img
                    src="/aurodomus-logo.png"
                    alt=""
                    aria-hidden="true"
                    className="bi-brand-spinner__logo"
                    width={dim}
                    height={dim}
                    style={{ display: 'block' }}
                />
            </span>
            {label ? <p className="bi-brand-spinner__label">{label}</p> : null}
        </div>
    );
}
